export default {
  name: 'marking--atkDocumentImport',
  apiService: 'shoes',
  apiPath: '/admin/document/upload',
  sendPath: '/admin/atk/func/send',
  urlParamName: 'marking--atkDocumentImport',
};